import { Loader } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { useAuth } from 'src/auth'
import { GET_COMPANY } from 'src/graphql/companies.graphql'
import { GET_EMPLOYEES_ONLY } from 'src/graphql/employees.graphql'

import CompanyDetailsPage from './components/CompanyDetailsPage'

const CompanyTab = () => {
  const { currentUser } = useAuth()
  const companyId = currentUser?.companyId

  const { data: companyData, loading } = useQuery(GET_COMPANY, {
    variables: { id: companyId },
    skip: !companyId,
  })

  const { data: recruitersData, loading: loadingRecruiters } = useQuery(
    GET_EMPLOYEES_ONLY,
    {
      variables: {
        filters: { roleTypes: ['RECRUITER'], companyId },
        pageInfo: { limit: 1000, offset: 0 },
      },
      skip: !companyId,
    }
  )

  const company = companyData?.company
  const recruiters = recruitersData?.employees?.items ?? []

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader color="gray" size="xs" />
      </div>
    )
  }
  return (
    <CompanyDetailsPage
      company={company}
      recruiters={recruiters}
      initialLoading={loadingRecruiters}
    />
  )
}

export default CompanyTab
